/**
 * Header search + Algolia for viewports ≤989px (modal). Desktop from 990px: header.liquid
 * `kingsleyHeaderSearchPlace` + base.css `.mobile-only` / `.desktop-only`.
 *
 * details-modal.js defers body click on header search and dispatches `kingsley:headersearchopened`.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 989px)');
  var HEADER_SEARCH_PLACEHOLDER = 'Search:';

  function ensureHeaderSearchPlaceholder(scope, force) {
    var root = scope || document;
    var inputs = root.querySelectorAll(
      '#kingsley-header-search-root input.aa-Input, #kingsley-header-search-root input[type="search"]'
    );
    inputs.forEach(function (input) {
      if (!input.placeholder || !String(input.placeholder).trim()) {
        input.placeholder = HEADER_SEARCH_PLACEHOLDER;
      } else if (force && input.placeholder !== HEADER_SEARCH_PLACEHOLDER) {
        input.placeholder = HEADER_SEARCH_PLACEHOLDER;
      }
    });
  }

  function dispatchAlgoliaSectionHook() {
    document.dispatchEvent(
      new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: 'algolia-shopify-instantsearch' },
      })
    );
  }

  /** Keep #kingsley-header-search-root in the correct slot before waking Algolia (resize race). */
  function ensureSearchRootPlaced() {
    try {
      if (typeof window.kingsleyHeaderSearchPlace === 'function') {
        window.kingsleyHeaderSearchPlace();
      }
    } catch (e) {}
  }

  function wakeAlgoliaInput(input) {
    if (!input || typeof input.focus !== 'function') return;
    var useReadonlyIosWake =
      MOBILE.matches &&
      input.id === 'Search-In-Header' &&
      !input.classList.contains('aa-Input');

    function focusAndWake(includeHeavy) {
      try {
        input.focus({ preventScroll: true });
      } catch (e) {}
      if (includeHeavy) {
        try {
          if (typeof input.click === 'function') input.click();
        } catch (e) {}
      }
      try {
        if (typeof FocusEvent === 'function') {
          input.dispatchEvent(new FocusEvent('focusin', { bubbles: true, composed: true }));
        }
        input.dispatchEvent(new Event('focus', { bubbles: true }));
      } catch (e) {}
      try {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
      dispatchAlgoliaSectionHook();
    }

    if (useReadonlyIosWake) {
      try {
        input.setAttribute('readonly', 'readonly');
      } catch (e) {}
      focusAndWake(true);
      queueMicrotask(function () {
        try {
          input.removeAttribute('readonly');
        } catch (e) {}
        focusAndWake(true);
      });
      window.requestAnimationFrame(function () {
        focusAndWake(true);
        window.requestAnimationFrame(function () {
          focusAndWake(true);
        });
      });
      window.setTimeout(function () {
        focusAndWake(true);
      }, 0);
      window.setTimeout(function () {
        focusAndWake(true);
      }, 32);
      window.setTimeout(function () {
        focusAndWake(true);
      }, 160);
    } else if (MOBILE.matches) {
      /* Single burst, no synthetic click — reduces floating-label / placeholder flicker. */
      focusAndWake(false);
    } else {
      focusAndWake(true);
    }
  }

  /**
   * Focus only the visible primary field. Focusing native + aa in sequence caused placeholder flicker.
   */
  function wakePrimaryHeaderSearchInput(root) {
    if (!root) return;
    var native = document.getElementById('Search-In-Header');
    var aa =
      root.querySelector('input.aa-Input') ||
      root.querySelector('.aa-Input input') ||
      root.querySelector('.aa-Autocomplete input');
    var target =
      aa ||
      (native && root.contains(native) ? native : null) ||
      root.querySelector('input[type="search"]');
    if (!target) return;
    wakeAlgoliaInput(target);
    if (aa && native && root.contains(native) && aa !== native) {
      try {
        native.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
    }
  }

  function nudgeAlgoliaWithoutRefocus() {
    try {
      window.dispatchEvent(new Event('resize'));
    } catch (e) {}
    dispatchAlgoliaSectionHook();
  }

  function observeAlgoliaMount(root) {
    if (!root || root.dataset.kingsleyAaObserve === '1') return;
    root.dataset.kingsleyAaObserve = '1';
    var obs = new MutationObserver(function () {
      ensureHeaderSearchPlaceholder(root, false);
      var aaInp = root.querySelector('input.aa-Input') || root.querySelector('.aa-Input input');
      if (aaInp) {
        obs.disconnect();
        delete root.dataset.kingsleyAaObserve;
        if (!aaInp.placeholder || !String(aaInp.placeholder).trim()) {
          aaInp.placeholder = HEADER_SEARCH_PLACEHOLDER;
        }
        ensureSearchRootPlaced();
        wakePrimaryHeaderSearchInput(root);
      }
    });
    obs.observe(root, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (root.dataset.kingsleyAaObserve === '1') {
        obs.disconnect();
        delete root.dataset.kingsleyAaObserve;
      }
    }, 4000);
  }

  function activateHeaderSearchAlgolia() {
    if (!MOBILE.matches) return;
    var root = document.getElementById('kingsley-header-search-root');
    if (!root) return;

    ensureSearchRootPlaced();
    ensureHeaderSearchPlaceholder(root, false);

    try {
      var url = new URL(window.location.href);
      var queryValue = url.searchParams.get('q');
      var native = document.getElementById('Search-In-Header');
      if (queryValue && native && root.contains(native) && native.value !== queryValue) {
        native.value = queryValue;
        native.setAttribute('value', queryValue);
        native.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } catch (e) {}

    dispatchAlgoliaSectionHook();
    observeAlgoliaMount(root);
    wakePrimaryHeaderSearchInput(root);
  }

  function onHeaderSearchOpened() {
    activateHeaderSearchAlgolia();
    [200, 600].forEach(function (delay) {
      window.setTimeout(function () {
        if (!document.querySelector('details-modal.header__search details[open]')) return;
        nudgeAlgoliaWithoutRefocus();
      }, delay);
    });
  }

  document.addEventListener('kingsley:headersearchopened', onHeaderSearchOpened);

  if (typeof MOBILE.addEventListener === 'function') {
    MOBILE.addEventListener('change', function () {
      ensureSearchRootPlaced();
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
      dispatchAlgoliaSectionHook();
    });
  }

  window.addEventListener('load', function () {
    ensureHeaderSearchPlaceholder(document, false);
    if (!MOBILE.matches) return;
    var details = document.querySelector('details-modal.header__search details[open]');
    if (details) activateHeaderSearchAlgolia();
  });

  document.addEventListener('shopify:section:load', function () {
    ensureHeaderSearchPlaceholder(document, false);
  });
})();
